/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

/**
 * Format a publication ISO timestamp as short local date + time (e.g. 31/07/26 14:30).
 */
export function formatPublicationTimestamp(
  value: string,
  locale?: string,
  timeZone?: string,
): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    ...(timeZone ? { timeZone } : {}),
  });
}
